/**
 * The write-through: the game's `Storage`, unchanged in what it does - the local write happens
 * first, synchronously, exactly as before - plus a word to the cloud layer that the key may have
 * changed. Reads never touch the network.
 */

import type { Storage } from '../../meta/api';

export function createSyncedStorage(base: Storage, cloud: { touch(key: string): void }): Storage {
  return {
    load: (key) => base.load(key),
    save(key, value) {
      base.save(key, value);
      cloud.touch(key);
    },
  };
}
